export class Brands {
    public static Init(): Brands {
        return new Brands();
    }

    constructor() {
        this.wireUpEventHandlers();
    }

    private wireUpEventHandlers() {
        document.querySelectorAll(".alphabet-select ul li").forEach((element) => {
            element.addEventListener("click", (e) => this.onAlphabetClicked(e, element));
        });
    }

    private onAlphabetClicked(e: Event, linkClicked: Element): void {
        let currentLetter = linkClicked.textContent.charAt(0);
        let currentTitle = linkClicked.textContent;

        e.preventDefault();

        if (linkClicked.classList.contains("select-all")) {
            document.querySelector(".brands-list h2.c-selected-title").textContent = currentTitle;

            document.querySelectorAll("ul.c-brand-column li")
                .forEach((element: HTMLElement) => {
                    element.classList.remove("hidden");
                    element.style.display = "block";
                });

            document.querySelectorAll(".brands-list .brands-list-generated")
                .forEach((element) => {
                    element.remove();
                });
        } else if (linkClicked.classList.contains("empty")) {
            //Do nothing
        } else if (linkClicked.classList.contains("select-number")) { // These brands are not shown as number links but grouped under the # symbol.
            let brandNumberLinks = document.querySelectorAll("ul.c-brand-column li.item-number");

            this.buildListFromBrandClass(currentTitle, brandNumberLinks);
        } else {
            let brandLinks = document.querySelectorAll("ul.c-brand-column li.item-" + currentLetter);

            this.buildListFromBrandClass(currentTitle, brandLinks);
        }
    }

    private buildListFromBrandClass(currentTitle: string, brandLinks: NodeListOf<Element>) {

        document.querySelector(".brands-list h2.c-selected-title").textContent = currentTitle;

        document.querySelectorAll("ul.c-brand-column li")
            .forEach((element: HTMLElement) => {
                element.classList.add("hidden");
            });

        let brandListElement = document.querySelector(".brands-list .brands-list-generated");
        if (brandListElement) {
            brandListElement.remove();
        }

        document.querySelector(".brands-list")
            .insertAdjacentHTML("beforeend", "<div class='brands-list-generated'><ul></ul></div>");

        brandListElement = document.querySelector(".brands-list .brands-list-generated ul");
        for (const brandLink of brandLinks) {
            brandListElement.insertAdjacentHTML("beforeend", "<li>" + brandLink.innerHTML + "</li>");
        }
    }
}
if (document.body.dataset.pageInit == "brands") {
    Brands.Init();
}